export default __webpack_public_path__ + "static/media/w_m_2022_a.2937b675.jpeg";